import React, { useState } from 'react';

const CodeBlock = ({ code, lang = 'text' }) => {
  const [copied, setCopied] = useState(false);

  const copy = () => {
    navigator.clipboard.writeText(code).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  // Basic syntax highlighting
  const highlight = (line) => {
    const tokens = [];
    let remaining = line;
    let key = 0;

    // Patterns: comments, strings, keywords, numbers, http methods, json keys
    const patterns = [
      { re: /^(\/\/.*|#.*)/, cls: 'code-comment' },
      { re: /^("(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*'|`(?:[^`\\]|\\.)*`)/, cls: 'code-string' },
      { re: /^(GET|POST|PUT|DELETE|PATCH|HEAD|OPTIONS)\b/, cls: 'code-method' },
      { re: /^(\b(?:const|let|var|function|class|return|import|export|from|if|else|for|while|async|await|new|this|null|undefined|true|false|try|catch|throw)\b)/, cls: 'code-keyword' },
      { re: /^(\b\d+(?:\.\d+)?\b)/, cls: 'code-number' },
      { re: /^([a-zA-Z_$][a-zA-Z0-9_$]*)\s*(?=\()/, cls: 'code-function' },
      { re: /^("?[a-zA-Z_][a-zA-Z0-9_]*"?\s*:)/, cls: 'code-param' },
      { re: /^([{}[\],;()])/, cls: 'code-punctuation' },
      { re: /^(\s+)/, cls: null },
      { re: /^([^\s{}[\](),"'`]+)/, cls: null },
    ];

    while (remaining.length > 0) {
      let matched = false;
      for (const { re, cls } of patterns) {
        const m = remaining.match(re);
        if (m) {
          const text = m[1] || m[0];
          tokens.push(cls
            ? <span key={key++} className={cls}>{text}</span>
            : <span key={key++}>{text}</span>
          );
          remaining = remaining.slice(m[0].length);
          matched = true;
          break;
        }
      }
      if (!matched) {
        tokens.push(<span key={key++}>{remaining[0]}</span>);
        remaining = remaining.slice(1);
      }
    }
    return tokens;
  };

  const lines = code.split('\n');

  return (
    <div className="code-window guide-code-window">
      <div className="code-header">
        <div className="dots">
          <span></span><span></span><span></span>
        </div>
        <span className="code-title">{lang}</span>
        <button className="code-copy-btn" onClick={copy}>
          {copied ? '✓ Copied' : 'Copy'}
        </button>
      </div>
      <div className="code-content guide-code-content">
        {lines.map((line, i) => (
          <div key={i} className="code-line">
            <span className="line-number">{i + 1}</span>
            <span className="code-line-body">{highlight(line)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CodeBlock;
